module.exports = __webpack_public_path__ + "static/img/btn-satisfaction-3-b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/btn-satisfaction-3-b.png
// module id = 521
// module chunks = 0